<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters(['getActiveLang', 'urlIn'])
  },
  methods: {
    ...mapActions(['resetSession', 'chargeUrlIn']),
    // Metodo generico para reiniciar la variable selected de una opcion del select de filtros
    resetOneOption (options, filter) {
      Object.keys(this.options).forEach((key) => {
        if (this.options[key].prop === filter.prop) {
          this.options[key].selected = false
        }
      })
    },
    // Metodo para comprobar el formato correcto de un numero pasado por parametro, teniendo en cuenta que
    // puede ser negativo o no según parámetro
    checkCorrectNumber (value, isInteger) {
      let isNumber = false
      const numberWithDecimalSeparator = 1.1
      const charDecimal = numberWithDecimalSeparator.toLocaleString(this.getActiveLang).substring(1, 2)
      const expression = isInteger ? '^(-?([0-9]+)([' + charDecimal + ']?[0-9]+)?)$' : '^(([0-9]+)([' + charDecimal + ']?[0-9]+)?)$'
      const regex = new RegExp(expression)
      if (regex.test(value)) {
        isNumber = true
      }
      return isNumber
    },

    checkCorrectNumberOrderLine (value) {
      let isNumber = false
      const expression = String.raw`^(\d|([1-9]\d+))$`
      const regex = new RegExp(expression)
      if (regex.test(value)) {
        isNumber = true
      }
      return isNumber
    },

    checkCorrectEmail (value) {
      if (!value) {
        return false
      }
      const expression = String.raw`^\w+(?:[-._%+]+\w+)*[-._+]?@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)+$`
      const regex = new RegExp(expression)
      return regex.test(value)
    },

    checkCorrectPhoneNumber (value) {
      if (!value) {
        return false
      }
      const expression = String.raw`^(?:\+?(?:\d{1,5}( ?\(\d\))?|\(\+?\d{1,5}\)) ?-?)(?:\d ?-?){6,8}\d$`
      const regex = new RegExp(expression)
      return regex.test(value)
    },

    // Método que nos dice si el formato es erroneo por el signo, el . o la , o simplemente
    // no es numérico.
    getCharFailedNumeric (value) {
      let charErroreturn = 'NoNumeric'
      const numberWithDecimalSeparator = 1.1
      const charDecimal = numberWithDecimalSeparator.toLocaleString(this.getActiveLang).substring(1, 2)
      const regex = /-/
      if (regex.test(value)) {
        charErroreturn = '\"-\"' // eslint-disable-line no-useless-escape
      } else if (/,/.test(charDecimal)) {
        if (/\./.test(value)) {
          charErroreturn = '\"\.\"' // eslint-disable-line no-useless-escape
        }
      } else if (/,/.test(value)) {
        charErroreturn = '\",\"' // eslint-disable-line no-useless-escape
      }
      return charErroreturn
    },

    // Metodo para resetear la prop selected a todas las opciones de los filtros
    resetSelectedOptions (options) {
      Object.keys(options).forEach(function (key) {
        options[key].selected = false
      })
    },

    // Metodo para comprobar que filtros deben aparecer deshabilitados al crear los componentes
    checkListFilterSelected (options, listSelectedFilters) {
      Object.keys(options).forEach(function (key) {
        const elementToChange = listSelectedFilters.find(element => {
          return element.prop === options[key].prop
        })
        options[key].selected = elementToChange ? !options[key].selected : options[key].selected
      })
    },

    countDecimals (value) {
      // Reemplazamos la separacion decimal a traves de locale por el punto "."
      const numberWithDecimalSeparator = 1.1
      const charDecimal = numberWithDecimalSeparator.toLocaleString(this.getActiveLang).substring(1, 2)
      const valueFormatted = ('' + value).replace(charDecimal, '.')

      // Comprobamos si redondeando el numero es igual al propio numero, entonces no tiene decimales
      if (Math.floor(Number.parseFloat(valueFormatted)) === Number.parseFloat(valueFormatted)) return 0
      return valueFormatted.split('.')[1].length || 0
    },

    countIntegers (value) {
      // Reemplazamos la separacion decimal a traves de locale por el punto "."
      const numberWithDecimalSeparator = 1.1
      const charDecimal = numberWithDecimalSeparator.toLocaleString(this.getActiveLang).substring(1, 2)
      const valueFormatted = ('' + value).replace(charDecimal, '.')

      // Obtenemos la parte enter del número
      const valueTruncated = Math.trunc(Number.parseFloat(valueFormatted))
      if (valueTruncated) {
        return ('' + valueTruncated).length
      }
      return 1
    },

    // Garantiza que el objeto de error tenga la estructura mínima esperada.
    // Esto evita fallos al acceder a propiedades cuando el backend/axios devuelve respuestas incompletas o errores de red.
    ensureErrorData (error) {
      if (!error || typeof error !== 'object') {
        return { status: null, data: {} }
      }
      if (!error.data || typeof error.data !== 'object') {
        error.data = {}
      }
      return error
    },

    // Extrae el mensaje del backend si existe y no está vacío (ignorando espacios).
    // Usamos trim() para no mostrar notificaciones vacías ("   ").
    getBackendMessageTrimmed (error) {
      const message = error && error.data ? error.data.message : undefined
      if (message === null || message === undefined) return ''
      return String(message).trim()
    },

    // Asigna el mensaje final a error.data.message de forma segura y devuelve error normalizado a showNotificationError.
    setErrorMessage (error, message) {
      const safeError = this.ensureErrorData(error)
      safeError.data.message = message
      return safeError
    },

    // Notificación de errores
    async showNotificationError (error, delay, type) { // NOSONAR javascript:S3776
      // Normalizamos el error para evitar accesos a undefined.
      error = this.ensureErrorData(error)

      if (delay === undefined || !delay) {
        delay = 6000
      }
      if (type === undefined || !type) {
        type = 'error'
      }
      const errorArgList = error.data.errorArgList
      const errorSmsList = error.data.messageList
      const errorSms = error.data.message

      const resolveI18nOrRaw = (maybeKey) => {
        if (maybeKey === null || maybeKey === undefined) {
          return { text: '', isI18n: false }
        }
        if (typeof maybeKey !== 'string') {
          return { text: String(maybeKey), isI18n: false }
        }

        // vue-i18n: $t() devuelve la propia clave si no existe la traducción.
        // Preferimos mostrar texto literal del backend en ese caso.
        const translated = this.$t(maybeKey)
        const hasKey = typeof this.$te === 'function' ? this.$te(maybeKey) : translated !== maybeKey

        return hasKey
          ? { text: translated, isI18n: true }
          : { text: maybeKey, isI18n: false }
      }

      if (Array.isArray(errorArgList) && errorArgList.length > 0) {
        for (let i = 0; i < errorArgList.length; i++) { // NOSONAR javascript:S4138
          let valueTitle = this.$t(errorArgList[i].messageCode)
          if (errorArgList[i].arguments && errorArgList[i].arguments !== '') {
            const listaArgs = errorArgList[i].arguments.split('||')
            const valoresArgumentos = {}
            for (let i = 0; i < listaArgs.length; i++) {
              if (i > 0) {
                valoresArgumentos['argumento' + i] = listaArgs[i]
              } else {
                valoresArgumentos.argumento = listaArgs[i]
              }
            }
            valueTitle = (this.$t(errorArgList[i].messageCode, valoresArgumentos))
          }
          await this.$notify({

            title: valueTitle,
            type,
            position: 'top-right',
            customClass: 'b2b-notification-error',
            duration: delay
          })
        }
      } else if (Array.isArray(errorSmsList) && errorSmsList.length > 0) {
        for (let i = 0; i < errorSmsList.length; i++) { // NOSONAR javascript:S4138
          const { text: titleText } = resolveI18nOrRaw(errorSmsList[i])
          await this.$notify({
            title: titleText,
            type,
            position: 'top-right',
            customClass: 'b2b-notification-error',
            duration: delay
          })
        }
      } else if (typeof errorSmsList === 'string' && errorSmsList.trim().length > 0) {
        const { text: titleText } = resolveI18nOrRaw(errorSmsList)
        await this.$notify({
          title: titleText,
          type,
          position: 'top-right',
          customClass: 'b2b-notification-error',
          duration: delay
        })
      } else {
        try {
          const { text: messageTitle, isI18n } = resolveI18nOrRaw(errorSms)

          this.$notify({
            title: this.$t('auditory_status.ERROR'),
            message: messageTitle,
            // Solo permitimos HTML cuando viene de un texto i18n controlado.
            dangerouslyUseHTMLString: isI18n,
            type,
            position: 'top-right',
            customClass: 'b2b-notification-error',
            duration: delay
          })
        } catch (error) {
          console.log('No inicialized', error)
        }
      }
    },
    getDateFromDateTimePicker (filter) {
      const start = new Date()
      switch (filter) {
        case 'today':
          start.setDate(start.getDate())
          break
        case 'lastWeek':
          start.setDate(start.getDate() - 7)
          break
        case 'lastMonth':
          start.setMonth(start.getMonth() - 1)
          break
        case 'lastThreeMonths':
          start.setMonth(start.getMonth() - 3)
          break
        case 'lastYear':
          start.setMonth(start.getMonth() - 12)
          break
        case 'lastTwoYear':
          start.setMonth(start.getMonth() - 24)
          break
        default:
          break
      }
      start.setHours(0)
      start.setMinutes(0)
      start.setSeconds(0)

      const end = new Date()
      end.setHours(23)
      end.setMinutes(59)
      end.setSeconds(59)
      // picker.emit('pick', [start, end])
      return [start, end]
    }
  }
}
</script>
